import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetBuildingMapWorkOrdersQuery } from "../../store/services/api/work-order-api";
import {humanizeDate, humanizeEnum} from "../../utils/humanizers";
import { WorkOrder, WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface RejectedWorkOrderModalProps {
  workOrder: WorkOrder;
  isOpen:boolean
  onClose: () => void;
}

export default function RejectedWorkOrderModal({
  workOrder,
  isOpen,
  onClose
}: RejectedWorkOrderModalProps) {
  

 const navigation = useNavigation<any>();
  useEffect(() => {

    
  }, [isOpen, workOrder]);


  return (
    <>
      <Modal
        centered
        width={1000}
        title="Work Orders"
        open={isOpen}
        onCancel={onClose}
        onOk={null}
      >
        <Skeleton loading={false} active>
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2 }}>Rejected By</div>
            <div style={{ flex: 2 }}>Date</div>
            <div style={{ flex: 2 }}>Reason</div>

          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={workOrder ? [workOrder] : []}
            renderItem={(item) => (
              <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                <div style={{ flex: 2 }}>{item.rejectedBy}</div>
                <div style={{ flex: 2 }}>{humanizeDate(item.rejectedOn)}</div>
                <div style={{ flex: 2 }}>{item.rejectedReason}</div>
              </List.Item>
            )}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
